export class UpdateDistributionList{
    name:string;
    devCodeList:string[] = new Array<string>();

}